import React,{useEffect,useState} from 'react'
import { AiOutlineMenu } from "react-icons/ai";
import { useStateContext } from '../../context/ContextProvider';
import avatar from '../../assets/avatar.png'
import {useNavigate} from 'react-router-dom'

const NavButton=({title,customFunc,icon,color,dotColor})=>(
      <button type='button' className='relative text-xl p-3  hover:bg-light-gray rounded-full'
        style={{color:'[#0f172a]'}}
        onClick={customFunc}>
      <span style={{background:dotColor}} className='
      absolute inline-flex rounded-full h-2 w-2 right-2 top-2'/>
        {icon}
      </button>
  )

  const DropdownMenu = ({ isVisible, logoutHandler,user }) => (
    <div className={`absolute right-0 top-full mt-1 mr-4 bg-white shadow-md rounded-lg ${isVisible ? 'block' : 'hidden'}`}>
      <ul className='p-2'>
        {/* <li className=''>{user.image}</li> */}
        <li className='cursor-pointer py-1 px-2'>{user.username}</li>
        <li onClick={logoutHandler} className='cursor-pointer py-1 px-2 text-[#49e6b7] hover:bg-gray-100 rounded-md'>Logout</li>
      </ul>
    </div>
  );


const Navbar = () => {
    const {setActiveMenu,screenSize,setScreenSize} = useStateContext()
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [user, setUser] = useState({ username: '', image: avatar });

  useEffect(()=>{
    const handleResize = ()=>{
      setScreenSize(window.innerWidth)
    }
    window.addEventListener('resize',handleResize)
    handleResize()
    return ()=>window.removeEventListener('resize',handleResize)
  },[])

  useEffect(()=>{
    if(screenSize<=900){
      setActiveMenu(false)
    }
    else{
      setActiveMenu(true)
    }
  },[screenSize])

  useEffect(() => {
    // Retrieve the token from local storage
    const tokenString = localStorage.getItem('token');
    // console.log(tokenString)
    if (tokenString) {
      try {
        // Parse the token JSON string to an object
        const token = JSON.parse(tokenString).result;

        // Extract the required user information
        const { username, image } = token;
        setUser({ username, image:image });
      } catch (error) {
        console.error('Error parsing token:', error);
      }
    }
  }, []);
  // console.log(user.image)

  const navigate = useNavigate();

  const handleLogout = () => {
    // Add your logout logic here
    localStorage.removeItem('token');
    navigate('/login')
  };

  const absoluteURL = `${process.env.REACT_APP_SERVER_BASE_URL}/${user.image}`;

  return (
    <div className='flex justify-between p-2 relative bg-skin-fill w-full'>
      <NavButton 
      title="menu" 
      customFunc={()=>setActiveMenu((prevActiveMenu)=>!prevActiveMenu)} 
      color="blue" 
      icon={<AiOutlineMenu/>}/>
      <div className='flex'>
      {/* <NavButton 
      title="cart" 
      customFunc={()=>{}} 
      color="blue" 
      icon={<FiCamera/>}/> */}

        <div className='z-50 mr-7'>
        <div className='flex items-center gap-1 cursor-pointer p-1 hover:bg-light-gray rounded-lg ' onClick={() => setDropdownVisible(!dropdownVisible)}>
        {user.image !== null ? (
            <img src={absoluteURL} alt='Profile' className='h-10 w-10 rounded-full overflow-hidden flex items-center justify-center cursor-pointer object-cover' />
          ) : (
            <img src={avatar} alt='Profile' className='h-10 w-10 rounded-full' />
          )}
        <p>
          {/* {user.email || 'Guest'} */}
        </p>
        {/* <BsArrowDownShort className='text-[26px]' /> */}
        <DropdownMenu isVisible={dropdownVisible} logoutHandler={handleLogout} user={user}/>
      </div>
      </div>
    

      </div>
    </div>
  )
}

export default Navbar